import { LanguageTestTemplate } from '../../lib/types/models/language-test/language-test-template'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

interface GetLanguageTestTemplatesRequest {
  search?: string
}

export const getLanguageTestTemplates = (options?: GetLanguageTestTemplatesRequest) =>
  restApiClient
    .url(
      encodeNestedObject<GetLanguageTestTemplatesRequest>(
        API.languageTest.getTemplates.url,
        options
      )
    )
    .get<LanguageTestTemplate[]>()
